/**
 * @fileoverview added by tsickle
 * Generated from: util/list-utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Return a list separated with commas, and with an "and" before the final
 * items in the list.
 * \@example
 * >>> andJoinedList(['foo', 'bar', 'baz'])
 * "foo, bar, and baz"
 *  /
 * >>> andJoinedList(['foo', 'bar', 'baz'], false)
 * "foo, bar and baz"
 *  /
 * >>> andJoinedList(['foo', 'bar'])
 * "foo and bar"
 * @param {?} list string[]
 * @param {?=} serialComma boolean  If true, add a serial comma ("Oxford comma")
 * @return {?} string
 *
 */
export function andJoinedList(list, serialComma) {
    if (serialComma === void 0) { serialComma = true; }
    if (!list || list.length === 0) {
        return '';
    }
    /** @type {?} */
    var andSeparator = serialComma && list.length > 2 ? ', and ' : ' and ';
    return list.reduce((/**
     * @param {?} a
     * @param {?} b
     * @param {?} i
     * @return {?}
     */
    function (a, b, i) { return "" + a + (i === list.length - 1 ? andSeparator : ', ') + b; }));
}
/**
 * Remove duplicate object from an array based on a unique object attribute
 *
 * \@example
 * >>> dedupeArray([{id: 1}, {id: 1}, {id: 2}], 'id')
 * [{id: 1}, {id: 2}]
 *
 * @template T
 * @param {?} arr The array which may contain duplicates
 * @param {?} uniqueKey The object key to which to treat as unique
 * @return {?}
 */
export function dedupeArray(arr, uniqueKey) {
    return arr.filter((/**
     * @param {?} v
     * @param {?} i
     * @param {?} a
     * @return {?}
     */
    function (v, i, a) { return a.findIndex((/**
     * @param {?} t
     * @return {?}
     */
    function (t) { return t[uniqueKey] === v[uniqueKey]; })) === i; }));
}
